import { StoreState } from '../../types';

export const getOverview = (state: StoreState) => state.employeeDashboard.overview.overview;
export const getOverviewShifts = (state: StoreState) => state.employeeDashboard.overview.shifts;